import React, { useState } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Tooltip, useMediaQuery, Fab } from "@material-ui/core";
import { SpeedDial, SpeedDialIcon, SpeedDialAction } from "@material-ui/lab";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
// import PhotoCameraIcon from "@material-ui/icons/PhotoCamera"; // Removed
// import BuildIcon from "@material-ui/icons/Build"; // Removed
import CloseIcon from "@material-ui/icons/Close";
import ImageToPortraitDialog from "./ImageToPortraitDialog";
import MobileUploadButton from "./MobileUploadButton";

const useStyles = makeStyles((theme) => ({
  speedDial: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    zIndex: 99999, // Increased z-index to ensure it's on top
  },
  tooltip: {
    fontSize: "0.75rem",
  },
  speedDialAction: {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  uploadAction: {
    backgroundColor: "#3f51b5", // Blue for upload
    color: theme.palette.common.white,
    "&:hover": {
      backgroundColor: "#303f9f",
    },
  },
  portraitAction: {
    backgroundColor: "#4caf50", // Green for portraits
    color: theme.palette.common.white,
    "&:hover": {
      backgroundColor: "#43a047",
    },
  },
}));

const ToolsFab = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = useState(false);
  const [portraitDialogOpen, setPortraitDialogOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // We no longer need the handleUploadClick function as we're using the MobileUploadButton component

  const handlePortraitClick = () => {
    console.log("ToolsFab: Portrait button clicked");
    setPortraitDialogOpen(true);
    setOpen(false);
  };

  const handlePortraitDialogClose = () => {
    setPortraitDialogOpen(false);
  };

  const actions = [
    {
      icon: <CloudUploadIcon />,
      name: "Upload & Autofill",
      tooltip: "Upload documents to autofill your application",
      component: MobileUploadButton,
      className: classes.uploadAction,
    },
    {
      icon: (
        <img
          src="https://firebasestorage.googleapis.com/v0/b/resumerevival-bb193.appspot.com/o/ai_camera.svg?alt=media&token=a83665a9-6c65-49cf-bba5-0bfd9ebf6b58"
          alt="Portraits icon"
          style={{ width: 24, height: 24, filter: "brightness(0) invert(1)" }}
        />
      ),
      name: "Portraits",
      tooltip: "Generate professional portraits",
      onClick: handlePortraitClick,
      className: classes.portraitAction,
    },
  ];

  // Add a direct click handler for debugging
  const handleMainFabClick = () => {
    console.log("ToolsFab: Direct main FAB click handler");
    setOpen(!open);
  };

  return (
    <>
      {/* Simplified approach - just use direct buttons instead of SpeedDial */}
      <div
        style={{
          position: "fixed",
          bottom: "16px",
          right: "16px",
          zIndex: 100000,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {/* When closed, show just the main button */}
        {!open && (
          <Tooltip title="Open tools menu">
            <Fab
              color="primary"
              aria-label="tools"
              onClick={handleMainFabClick}
              style={{ marginBottom: "8px" }}
            >
              <img
                src="https://firebasestorage.googleapis.com/v0/b/resumerevival-bb193.appspot.com/o/ai_build.svg?alt=media&token=6e91391b-fb8a-4383-890a-b41a59beb362"
                alt="Open tools menu icon"
                style={{
                  width: 40, // Increased size
                  height: 40, // Increased size
                  filter: "brightness(0) invert(1)",
                }}
              />
            </Fab>
          </Tooltip>
        )}

        {/* When open, show the action buttons */}
        {open && (
          <>
            {actions.map((action, index) =>
              action.component ? (
                // If the action has a component property, render that component
                <action.component
                  key={action.name}
                  isCompact={true}
                  onClose={handleClose}
                />
              ) : (
                // Otherwise render a regular Fab button
                <Tooltip key={action.name} title={action.tooltip}>
                  <Fab
                    size="medium"
                    aria-label={action.name}
                    onClick={action.onClick}
                    className={action.className}
                    style={{ marginBottom: "8px" }}
                  >
                    {action.icon}
                  </Fab>
                </Tooltip>
              )
            )}

            {/* Close button */}
            <Tooltip title="Close menu">
              <Fab
                color="primary"
                size="medium"
                aria-label="close"
                onClick={handleClose}
                style={{ backgroundColor: "#3f51b5" }}
              >
                <CloseIcon />
              </Fab>
            </Tooltip>
          </>
        )}
      </div>

      <ImageToPortraitDialog
        open={portraitDialogOpen}
        onClose={handlePortraitDialogClose}
      />
    </>
  );
};

export default ToolsFab;
